import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7061cc72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  colspan: "2",
  style: {"text-align":"center","font-weight":"bold"}
}



export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMethodUSDT',
  props: {
    wireForm: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.$t("fields.paymentMethod")), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.method")), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.wireForm.payment.paymentServiceName), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.usdtWalletAddress")), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.wireForm.bankInfo.walletAddress), 1)
    ])
  ]))
}
}

})